import React from "react";
import Modal from "../shared/Modal";
import "./ModalPolicyStudioWarning.css";
import ActionButton from "../common/ActionButton";
import { HUBSPOT_SIGNUP_LINK } from "../../config";
import { Button } from "../../ds2/components";

interface ModalPolicyStudioWarningProps {
  isOpen: boolean;
  onClose: () => void;
  value: string;
  escapeToClose?: boolean;
  allowClickout?: boolean;
  canClose?: boolean;
}

export const ModalPolicyStudioWarning: React.FC<
  ModalPolicyStudioWarningProps
> = ({ isOpen, onClose, value, escapeToClose, allowClickout, canClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "500px" }}
      canClose={canClose}
      escapeToClose={escapeToClose}
      allowClickout={allowClickout}>
      <div className="modal-policy-studio-warning">
        <div className="modal-policy-studio-warning-title">
          <h2>Just FYI!</h2>
        </div>
        <div className="modal-policy-studio-warning-body">
          <div className="modal-policy-studio-warning-content">
            <div className="modal-policy-studio-warning-label">
              {`You've got ${value} custom ${value === "1" ? "prompt" : "prompts"} left. Please book a demo
              with our team to learn more about Winslow.`}
            </div>
          </div>
        </div>
        <div className="modal-policy-studio-warning-buttons">
          {canClose && (
            <Button label="Dismiss" variant="primary" onClick={onClose} />
          )}

          <Button
            label="Talk to Sales"
            variant="tertiary"
            onClick={() => {
              window.open(HUBSPOT_SIGNUP_LINK, "_blank");
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
